<template>
  <div class="comments publick">
    <div class="commentsLeft fl">
      <div class="commentContent">
        <div class="top">
          <div class="txt fl">综合<br>评分</div>
          <div class="starNum fl">9.8</div>
          <div class="starDiv fl">
            <star :score="9.8"></star>
          </div>
          <div class="allStar fr">
            <span>内容实用: <b>9.6</b> </span>
            <span>简洁易懂: <b>9.8</b> </span>
          </div>
        </div>
        <div class="choice">
          <div class="t fl">请评分：</div>
          <div class="star fl">
            <span @click="results(index)" v-for="(itemClass, index) in result" :key="index" :class="itemClass"
                  class="star-item"></span>
          </div>
        </div>
        <div class="textarea">
          <textarea v-model="content"></textarea>
        </div>
        <div class="bot">
          <div class="save fr">确定</div>
        </div>
      </div>
      <ul>
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="65" height="65" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
              <span class="fr">2小时前</span>
            </div>
            <div class="p">感谢老师的入微指点，层次清晰，讲解全面</div>
          </div>
        </li>
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="65" height="65" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
              <span class="fr">2小时前</span>
            </div>
            <div class="p">部分课程里有亲子互动的环节，宝宝可以和爸爸妈妈一起学习，很有趣。老师的讲解也
              很生动易懂，后面还有朗读的课程，希望宝宝能学到更多的东西。
            </div>
          </div>
        </li>
        <li>
          <div class="img fl"><img src="../../../assets/portrait.png" width="65" height="65" alt=""></div>
          <div class="Txt fr">
            <div class="name">
              <span class="fl">彭小呆</span>
              <span class="fr">2小时前</span>
            </div>
            <div class="p">感谢老师的入微指点，层次清晰，讲解全面</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="detRight fr">
      <detRight></detRight>
    </div>

    <div style="clear: both;"></div>
    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="1000">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import star from '@/components/CourseDetails/star/star'
  import detRight from '@/components/CourseDetails/detRight/detRight'

  export default {
    components: {
      star,
      detRight
    },
    data () {
      return {
        page: 1,
        result: ['off', 'off', 'off', 'off', 'off'],
        content: '',
        starNum: 0
      }
    },
    methods: {
      pageChange (page) {
        this.page = page
      },
      results (index) {
        let result = []
        let score = (Math.floor(index + 1))
        for (let i = 0; i < score; i++) {
          result.push('on')
        }
        while (result.length < 5) {
          result.push('off')
        }
        this.starNum = (Math.floor(index + 1)) * 2
        this.result = result
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .comments {
    color: #535353;
    margin-bottom: 100px;
    overflow: hidden;

    .commentsLeft {
      .commentContent {
        margin-top: 40px;
        width: 700px;
        padding: 35px;
        box-shadow: 0px 0px 35px #f8f8f8;
        border-radius: 20px;
        overflow: hidden;

        .top {
          height: 38px;
          padding-bottom: 35px;
          border-bottom: 1px solid #ebebeb;

          .starNum {
            line-height: 38px;
            font-size: 38px;
            color: #404040;
            margin: 0 30px;
          }

          .starDiv {
            margin-top: 11.5px;
          }

          .allStar {
            line-height: 38px;
            font-size: 16px;

            b {
              color: #ffa419;
              margin: 0 5px;
            }

            span {
              margin-left: 40px;
            }
          }
        }

        .choice {
          margin: 35px auto;
          overflow: hidden;

          .star {
            display: block;
            height: 15px;
            float: left;
            overflow: hidden;
            margin-top: 3px;

            .star-item {
              width: 15px;
              height: 15px;
              display: inline-block;
              font-size: 0;
              border: 0;
            }

            .on {
              background: url("../star/star-on.png") no-repeat center center;
              background-size: 100% 100%;
            }

            .off {
              background: url("../star/star-off.png") no-repeat center center;
              background-size: 100% 100%;
            }
          }
        }

        .textarea {
          width: 100%;
          height: 175px;
          border: 1px solid #f8f8f8;
          color: #535353;
          overflow: hidden;

          textarea {
            width: 100%;
            height: 100%;
            font-size: 14px;
            border: 0;
            line-height: 25px;
            text-indent: 10px;
          }
        }

        .bot {
          height: 35px;
          overflow: hidden;
          margin: 35px auto 0;
          width: 100%;

          .save {
            width: 100px;
            height: 35px;
            border-radius: 20px;
            background-color: #ff8484;
            color: #fff;
            text-align: center;
            line-height: 35px;
          }
        }
      }

      ul {
        margin-top: 20px;
        width: 700px;
        padding: 35px;
        box-shadow: 0px 0px 35px #f8f8f8;
        border-radius: 20px;
        overflow: hidden;

        li {
          overflow: hidden;
          margin-top: 35px;

          &:first-child {
            margin: 0;
          }

          .img {
            width: 85px;
            height: 85px;
          }

          .Txt {
            width: 615px;

            .name {
              line-height: 25px;
              margin: 20px auto 0;
              width: 100%;
              height: 25px;
              overflow: hidden;

              .fl {
                font-size: 22px;
              }

              .fr {
                font-size: 14px;
                color: #b3b3b3;
              }
            }

            .p {
              font-size: 14px;
              margin: 10px auto 0;
              line-height: 30px;
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto 0;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/live/comments/comments.vue